/* Embertine Shop: Kollektion, Produkt, Warenkorb-Schublade. Nachbau von Prototyp src/js collection.js, product.js, cart.js (ohne gsap). Warenkorb ueber Shopify Ajax. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var CFG = window.EB_SHOP || {};
  var FREE = (CFG.free || 49) * 100, SHIP = (CFG.ship || 4.9) * 100, DAYS = CFG.days || '3-5', CUT = CFG.cutoff || 12, WD = CFG.withdrawal || 14;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function money(c) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(c / 100); } catch (e) { return (c / 100).toFixed(2) + ' ' + cur; }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
  function api(path, body) {
    return fetch(root + path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  /* ---------- Schublade ---------- */
  var cart = null;
  function panel() { return $('[data-cart-panel]'); }
  function openLayer() {
    var p = panel(), o = $('[data-eb-overlay]'); if (!p) { location.href = root + 'cart'; return; }
    p.classList.add('open'); p.setAttribute('aria-hidden', 'false'); if (o) o.classList.add('open');
    document.documentElement.style.overflow = 'hidden';
    var x = $('[data-close-cart]', p); if (x) x.focus();
  }
  function closeLayer() {
    var p = panel(), o = $('[data-eb-overlay]'); if (!p) return;
    p.classList.remove('open'); p.setAttribute('aria-hidden', 'true'); if (o) o.classList.remove('open');
    document.documentElement.style.overflow = '';
  }
  function count(n) {
    $$('.eb-count,[data-cart-count]').forEach(function (e) { e.textContent = n; e.hidden = !n; });
    var link = $('a.eb-icon-btn[href$="/cart"]');
    if (link) {
      link.setAttribute('aria-label', 'Bag, ' + n + ' items');
      if (n && !$('.eb-count', link)) { var s = document.createElement('span'); s.className = 'eb-count'; s.textContent = n; link.appendChild(s); }
    }
  }
  function load() { return api('cart.js').then(function (c) { cart = c; count(c.item_count); return c; }); }
  function line(it, i) {
    var meta = (it.variant_title && it.variant_title !== 'Default Title') ? '<span class="cl-meta">' + esc(it.variant_title) + '</span>' : '';
    if (it.selling_plan_allocation) meta += '<span class="cl-meta">' + esc(it.selling_plan_allocation.selling_plan.name) + '</span>';
    var disc = it.original_line_price > it.final_line_price;
    var why = (it.line_level_discount_allocations || []).map(function (d) { return '<span class="cl-why">' + esc(d.discount_application.title) + ' -' + money(d.amount) + '</span>'; }).join('');
    var im = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
    return '<div class="cl" data-line="' + (i + 1) + '" data-key="' + esc(it.key) + '">' +
      (im ? '<img src="' + esc(im) + '" alt="">' : '<span class="placeholder"></span>') +
      '<div class="cl-body"><a class="cl-title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + meta + why +
      '<div class="cl-row"><div class="qty"><button data-cq="-1" aria-label="Less">−</button><span>' + it.quantity + '</span><button data-cq="1" aria-label="More">+</button></div>' +
      '<span class="cl-price">' + (disc ? '<s>' + money(it.original_line_price) + '</s> ' : '') + money(it.final_line_price) + '</span></div>' +
      '<button class="cl-rm" data-rm>Remove</button></div></div>';
  }
  function render() {
    var body = $('[data-cart-body]'), foot = $('[data-cart-foot]'); if (!body || !cart) return;
    if (!cart.item_count) {
      body.innerHTML = '<div class="cart-empty"><p class="quote">Your bag is empty, and so is the candle holder.</p><a class="btn" href="' + root + 'collections/rituals">Find a ritual</a><a class="link-arrow" href="' + root + 'pages/quiz">Or let the quiz decide</a></div>';
      foot.innerHTML = ''; return;
    }
    var after = cart.total_price, toFree = Math.max(0, FREE - after), pct = Math.min(100, after / FREE * 100);
    var ship = toFree > 0 ? SHIP : 0, saved = cart.total_discount || 0;
    var gift = (cart.attributes && cart.attributes.gift_message) || '', noprice = cart.attributes && cart.attributes.gift_noprice === 'yes';
    var refills = cart.items.filter(function (i) { return i.properties && i.properties._refill; }).reduce(function (a, i) { return a + i.quantity; }, 0);
    body.innerHTML =
      '<div class="ship-bar">' + (toFree > 0 ? 'You are <b>' + money(toFree) + '</b> away from free shipping.' : '<b>Free shipping</b> is yours.') + '<div class="track"><div class="fill" style="width:' + pct + '%"></div></div></div>' +
      (refills === 1 ? '<p class="cart-hint">Add one more refill and save 10 % on both.</p>' : '') +
      '<div class="cl-list">' + cart.items.map(line).join('') + '</div>' +
      '<div class="cart-up" data-cart-up hidden></div>' +
      '<details class="cart-gift"' + (gift ? ' open' : '') + '><summary>This is a gift</summary>' +
      '<label class="field"><span class="sr">Message</span><textarea class="input" rows="3" maxlength="240" data-gift-msg placeholder="Your message for the card (printed digitally, sent by email to the recipient)">' + esc(gift) + '</textarea></label>' +
      '<label class="check"><input type="checkbox" data-gift-noprice' + (noprice ? ' checked' : '') + '> Hide prices on the delivery note</label></details>';
    foot.innerHTML =
      '<div class="sum"><span>Subtotal</span><span>' + money(cart.original_total_price || cart.items_subtotal_price) + '</span></div>' +
      (saved ? '<div class="sum good"><span>You save</span><span>-' + money(saved) + '</span></div>' : '') +
      '<div class="sum"><span>Shipping</span><span>' + (ship ? money(ship) : 'free') + '</span></div>' +
      '<div class="sum total"><span>Total incl. VAT</span><span>' + money(after + ship) + '</span></div>' +
      '<p class="embers-line">You earn <b>' + Math.floor(after / 100) + ' Embers</b> with this order</p>' +
      '<a class="btn btn-wide" href="' + root + 'checkout">Checkout · ' + money(after + ship) + '</a>' +
      '<div class="express"><span>Shop Pay</span><span>PayPal</span><span>Apple Pay</span></div>' +
      '<p class="fineprint">Delivered from our EU warehouse in ' + DAYS + ' working days · ' + WD + '-day right of withdrawal</p>';
    upsell();
  }
  function upsell() {
    var box = $('[data-cart-up]'); if (!box || !cart.items.length) return;
    api('recommendations/products.json?product_id=' + cart.items[0].product_id + '&limit=4&intent=complementary').then(function (r) {
      var have = cart.items.map(function (i) { return i.product_id; });
      var ps = (r.products || []).filter(function (p) { return have.indexOf(p.id) < 0 && p.available; }).slice(0, 3);
      if (!ps.length) return;
      box.innerHTML = '<p class="caps">Complete the ritual</p>' + ps.map(function (p) {
        return '<div class="cu"><img src="' + esc(p.featured_image || '') + '" alt=""><span>' + esc(p.title) + '<small>' + money(p.price) + '</small></span><button class="btn btn-sm btn-ghost" data-up="' + p.variants[0].id + '" aria-label="Add ' + esc(p.title) + '">+</button></div>';
      }).join('');
      box.hidden = false;
    }).catch(function () {});
  }
  function refresh() { return load().then(render); }
  function add(items, el) {
    if (el) { el.disabled = true; el.classList.add('busy'); }
    return api('cart/add.js', { items: items }).then(function () { return refresh(); }).then(openLayer)
      .catch(function (e) { alert((e && (e.description || e.message)) || 'Could not add to bag.'); })
      .then(function () { if (el) { el.disabled = false; el.classList.remove('busy'); } });
  }
  window.EBCart = { add: add, open: function () { refresh().then(openLayer); }, refresh: refresh };

  function initDrawer() {
    var p = panel(); if (!p) return;
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href$="/cart"],[data-open-cart]');
      if (a && !e.target.closest('[data-cart-panel]')) { e.preventDefault(); window.EBCart.open(); return; }
      if (e.target.closest('[data-close-cart],[data-eb-overlay]')) closeLayer();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLayer(); });
    p.addEventListener('click', function (e) {
      var l = e.target.closest('.cl'), q = e.target.closest('[data-cq]'), up = e.target.closest('[data-up]');
      if (up) { add([{ id: +up.dataset.up, quantity: 1 }], up); return; }
      if (!l) return;
      var it = cart.items[+l.dataset.line - 1], qty = it.quantity;
      if (q) qty += +q.dataset.cq; else if (e.target.closest('[data-rm]')) qty = 0; else return;
      l.style.opacity = '.5';
      api('cart/change.js', { id: l.dataset.key, quantity: Math.max(0, qty) }).then(function (c) { cart = c; count(c.item_count); render(); });
    });
    var t;
    p.addEventListener('input', function (e) {
      if (!e.target.matches('[data-gift-msg]')) return;
      clearTimeout(t); t = setTimeout(function () { api('cart/update.js', { attributes: { gift_message: e.target.value } }); }, 500);
    });
    p.addEventListener('change', function (e) {
      if (e.target.matches('[data-gift-noprice]')) api('cart/update.js', { attributes: { gift_noprice: e.target.checked ? 'yes' : 'no' } });
    });
    load().then(function () { document.dispatchEvent(new Event('eb:cart')); });
  }

  /* ---------- Kollektion ---------- */
  function initCollection() {
    var box = $('[data-collection]'); if (!box) return;
    var grid = $('[data-grid]', box), empty = $('[data-empty]', box);
    var cells = $$('.cell', grid), eds = $$('[data-ed]', grid), active = [];
    function match(el) {
      return active.every(function (f) {
        var k = f.split(':')[0], v = f.slice(k.length + 1);
        if (k === 'kind') return el.dataset.kind === v;
        if (k === 'type') return el.dataset.type === v;
        if (k === 'moment') return (' ' + el.dataset.moments + ' ').indexOf(' ' + v + ' ') > -1;
        if (k === 'vendor') return el.dataset.vendor === v;
        if (k === 'price') { var ab = v.split('-').map(Number), p = +el.dataset.price; return p >= ab[0] && p < ab[1]; }
        return true;
      });
    }
    function apply() {
      var n = 0;
      cells.forEach(function (el) { var ok = match(el); el.hidden = !ok; if (ok) n++; });
      eds.forEach(function (e) { e.hidden = active.length > 0 || ($('[data-sort]', box).value !== 'rec'); });
      empty.hidden = n > 0;
      $$('.pcard[data-reveal]', grid).forEach(function (x) { x.classList.add('in'); });
    }
    box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-f]'); if (!b) return;
      var f = b.dataset.f;
      if (f === 'all') { active = []; $$('[data-f]', box).forEach(function (x) { x.classList.toggle('on', x === b); }); }
      else {
        var k = f.split(':')[0];
        active = active.filter(function (a) {
          if (a.indexOf(k + ':') === 0 && a !== f) { $$('[data-f]', box).forEach(function (x) { if (x.dataset.f === a) x.classList.remove('on'); }); return false; }
          return true;
        });
        var i = active.indexOf(f);
        if (i > -1) active.splice(i, 1); else active.push(f);
        $$('[data-f]', box).forEach(function (x) { if (x.dataset.f === f) x.classList.toggle('on', i < 0); });
        $('[data-f="all"]', box).classList.toggle('on', active.length === 0);
      }
      var det = b.closest('details'); if (det && window.innerWidth < 620) det.open = false;
      apply();
    });
    $('[data-sort]', box).addEventListener('change', function (e) {
      var v = e.target.value;
      var all = $$('.cell,[data-ed]', grid);
      cells.slice().sort(function (a, b) {
        return v === 'asc' ? a.dataset.price - b.dataset.price : v === 'desc' ? b.dataset.price - a.dataset.price : v === 'new' ? b.dataset.created - a.dataset.created : a.dataset.order - b.dataset.order;
      }).forEach(function (el) { grid.appendChild(el); });
      if (v === 'rec') all.forEach(function (el) { grid.appendChild(el); });
      apply();
    });
    apply();
  }

  /* Schnellkauf auf Karten (Kollektion und ueberall, wo eb-product-card steht) */
  function initQuick() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-add]');
      if (b) { e.preventDefault(); add([{ id: +b.dataset.add, quantity: 1 }], b); return; }
      var q = e.target.closest('[data-quick-variants]');
      if (q) {
        e.preventDefault();
        var card = q.closest('.pcard'), old = $('.qv', card); if (old) { old.remove(); return; }
        var opts = JSON.parse(q.getAttribute('data-opts') || '[]');
        var pop = document.createElement('div'); pop.className = 'qv';
        pop.innerHTML = '<p class="caps">Choose</p><div class="qv-opts">' + opts.map(function (o) { return '<button class="chip" data-k="' + o.id + '"' + (o.a ? '' : ' disabled') + '>' + esc(o.n) + '</button>'; }).join('') + '</div><button class="x-btn" aria-label="Close"></button>';
        $('.pcard-media', card).appendChild(pop);
        pop.addEventListener('click', function (ev) {
          ev.preventDefault(); ev.stopPropagation();
          var k = ev.target.closest('[data-k]');
          if (k) { add([{ id: +k.dataset.k, quantity: 1 }], k).then(function () { pop.remove(); }); }
          else if (ev.target.closest('.x-btn')) pop.remove();
        });
      }
    });
  }

  /* ---------- Produkt ---------- */
  function initProduct() {
    var pd = $('[data-product]'); if (!pd) return;
    var data = JSON.parse(($('[data-product-json]', pd) || {}).textContent || '{}');
    var variants = data.variants || [], variant = variants.filter(function (v) { return v.id === data.selected; })[0] || variants[0];
    var qty = 1;
    /* Galerie */
    var slides = $$('.pd-slide', pd), thumbs = $$('[data-thumb]', pd);
    function show(key) {
      if (!slides.some(function (s) { return s.dataset.slide === String(key); })) return;
      slides.forEach(function (s) { s.classList.toggle('on', s.dataset.slide === String(key)); });
      thumbs.forEach(function (t) { t.classList.toggle('on', t.dataset.thumb === String(key)); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.thumb); }); });
    var z = $('[data-zoom]', pd); if (z) z.addEventListener('click', function () { var on = $('.pd-slide.on', pd); if (on && on.requestFullscreen) on.requestFullscreen(); });
    var main = $('.pd-main', pd), x0 = null;
    if (main) {
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) < 40) return;
        var i = slides.indexOf($('.pd-slide.on', pd)), n = (i + (dx < 0 ? 1 : -1) + slides.length) % slides.length; show(slides[n].dataset.slide);
      });
    }
    /* Preis und Anzeigen */
    function update() {
      var unit = variant ? variant.price : +pd.dataset.price;
      var sub = $('input[name="buy"]:checked', pd);
      if (sub && sub.value === 'sub') unit = Math.round(unit * 0.9);
      var tot = unit * qty;
      $$('[data-price-out]', pd).forEach(function (e) { e.textContent = money(unit); });
      $$('[data-btn-price],[data-sticky-price]').forEach(function (e) { e.textContent = money(tot); });
      $$('[data-embers]', pd).forEach(function (e) { e.textContent = Math.floor(tot / 100); });
      var q = $('[data-qty] span', pd); if (q) q.textContent = qty;
      shipBar(tot); stock();
    }
    function shipBar(addC) {
      var el = $('[data-pd-ship]', pd); if (!el) return;
      var after = (cart ? cart.total_price : 0) + addC, rest = Math.max(0, FREE - after);
      el.innerHTML = (rest > 0 ? 'With this you are <b>' + money(rest) + '</b> away from free shipping' : 'With this, <b>shipping is free</b>') + '<div class="track"><div class="fill" style="width:' + Math.min(100, after / FREE * 100) + '%"></div></div>';
    }
    function stock() {
      var el = $('[data-stock]', pd); if (!el) return;
      var av = variant ? variant.available : true, st = variant && variant.inventory_management ? variant.qty : null;
      el.innerHTML = !av ? '<i class="dot bad"></i>Sold out' : (st != null && st > 0 && st <= 3) ? '<i class="dot warn"></i>Only ' + st + ' left · delivered in ' + DAYS + ' working days' : '<i class="dot ok"></i>In stock · delivered in ' + DAYS + ' working days';
      $$('[data-pd-add]').forEach(function (b) { b.disabled = !av; });
    }
    var cut = $('[data-cutoff]', pd);
    function tickCut() {
      var now = new Date(), d = now.getDay(), c = new Date(now); c.setHours(CUT, 0, 0, 0);
      if (d === 0 || d === 6 || now > c) { cut.textContent = 'Order now, dispatched on the next working day'; return; }
      var ms = c - now; cut.textContent = 'Order within ' + Math.floor(ms / 36e5) + ' h ' + Math.floor((ms % 36e5) / 6e4) + ' min for dispatch today';
    }
    if (cut) { tickCut(); setInterval(tickCut, 30000); }
    /* Varianten */
    $$('.var-btn', pd).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('.var-btn', pd).forEach(function (x) { x.setAttribute('aria-checked', String(x === b)); });
        variant = variants.filter(function (v) { return String(v.id) === b.dataset.v; })[0] || variant;
        var n = $('[data-var-name]', pd); if (n) n.textContent = b.dataset.vName;
        $$('[data-sku]', pd).forEach(function (e) { e.textContent = variant.sku || ''; });
        if (variant.media) show(variant.media);
        var u = new URL(location.href); u.searchParams.set('variant', variant.id); history.replaceState(null, '', u);
        update();
      });
    });
    $$('[data-qty] [data-q]', pd).forEach(function (b) { b.addEventListener('click', function () { qty = Math.max(1, qty + +b.dataset.q); update(); }); });
    $$('.sub-opt input', pd).forEach(function (r) {
      r.addEventListener('change', function () { $$('.sub-opt', pd).forEach(function (l) { l.classList.toggle('on', $('input', l).checked); }); update(); });
    });
    function doAdd(el) {
      if (!variant) return;
      var it = { id: variant.id, quantity: qty, properties: {} };
      var sub = $('input[name="buy"]:checked', pd);
      if (sub && sub.value === 'sub' && sub.dataset.plan) it.selling_plan = +sub.dataset.plan;
      if (pd.dataset.refill === '1') it.properties._refill = '1';
      var items = [it];
      return add(items, el);
    }
    $$('[data-pd-add]').forEach(function (b) { b.addEventListener('click', function () { doAdd(b); }); });
    var all = $('[data-add-all]', pd);
    if (all) all.addEventListener('click', function () {
      var items = [{ id: variant.id, quantity: qty }];
      $$('[data-cmp]:checked', pd).forEach(function (x) { items.push({ id: +x.dataset.cmp, quantity: 1 }); });
      add(items, all);
    });
    /* Klebende Kaufleiste */
    var bar = $('[data-sticky]'), cta = $('.pd-cta', pd);
    if (bar && cta && 'IntersectionObserver' in window) new IntersectionObserver(function (en) {
      var e = en[0], on = !e.isIntersecting && (e.boundingClientRect.top < 0 || matchMedia('(max-width: 900px)').matches);
      bar.classList.toggle('on', on); bar.setAttribute('aria-hidden', String(!on));
    }).observe(cta);
    update();
    document.addEventListener('eb:cart', update);
  }

  function boot() {
    initDrawer(); initCollection(); initQuick(); initProduct();
    var _r = refresh; refresh = function () { return _r().then(function () { document.dispatchEvent(new Event('eb:cart')); }); };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
